import { TenantName } from '@shared/models/tenant-name';

export enum TransactionType {
    Deposit = 'Deposit',
    Withdraw = 'Withdraw',
}
export interface PayCreditStoredCard {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: PayLoadStoredCard;
}

export interface PayCreditNewCard {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: PayLoadNewCard;
}

export interface PaySkill {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: PayLoadNewCard;
    device_info?: {
        ip: string;
    };
}

export interface PayBpay {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: PayLoadNewCard;
    device_info?: {
        ip: string;
    };
}

export interface PayPoli {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: PayLoadNewCard;
}

export interface PayFasapay {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: PayLoadNewCard;
    device_info?: {
        ip: string;
    };
}

export interface PayAvodapay {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: PayLoadAvodapay;
    device_info?: {
        ip: string;
    };
}

export interface PayLoadAvodapay {
    china_id?: string;
    name_in_chinese?: string;
    telephone?: string;
    china_card_number?: string;
}

export interface PayNeteller {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: {
        email?: string;
        secure_id?: string;
    };
    device_info?: {
        ip: string;
    };
}

export interface PayUnion {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: {
        bank_code?: string;
        account_name?: string;
        name?: string;
    };
    device_info?: {
        ip: string;
    };
}

export interface PayP2P {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: {
        user_name?: string;
        user_id?: string;
        user_cardno?: string;
    };
}

export interface PayLoadStoredCard {
    '3ds': boolean;
}
export interface PayLoadNewCard {
    '3ds'?: boolean;
    card_number?: string;
    card_label?: string;
    cvv?: string;
    expiry_date?: string;
}

export enum PaymentMethod {
    Visa = 'visa',
    Skrill = 'skrill',
    Neteller = 'neteller',
    Bpay = 'bpay',
    Poli = 'poli',
    Fasapay = 'fasapay',
    Avodapay = 'avodapay',
    Cup = 'cup_desktop',
    Alipay = 'alipay',
    Union = 'union',
    BankWire = 'bank_wire',
}

export enum UnionType {
    Jarvis = 'JARVIS',
    Xpay = 'XPAY',
    Alopay = 'ALOPAY',
    RPNP2P = 'RPNP2P',
}

// Generated by https://quicktype.io

export interface CreditCardPaymentResult {
    reference?: string;
    url_target?: string;
    payment_gateway?: string;
    pay?: PayResult;
}

export interface PayResult {
    merchant_id?: string;
    amount?: number;
    currency?: string;
    fingerprint?: string;
    callback_uri?: string;
    done_uri?: string;
}

// Generated by https://quicktype.io

export interface Deposit {
    id?: string;
    status?: string;
    deposit_amount?: number;
    deposit_currency?: string;
    deposit_fee?: string;
    settlement_amount?: string;
    settlement_currency?: string;
    order_number?: null;
    detail?: string;
    conversion_rate?: number;
    conversion_date?: string;
    ip_address?: string;
    created_date?: string;
    updated_date?: string;
    trading_account?: string;
    payment_device?: string;
    payment_gateway?: string;
    payment_platform?: string;
    tenant?: TenantName;
    refunded_amount?: number;
    loading?: boolean;
    payout?: Array<any>;
    users_linked?: {
        id: string;
        email: string;
    }[];

    country?: string;
}

export interface CreditCardPaymentGatewayResponse {
    paymentDeviceModel?: PaymentDeviceModel;
    fraudLabsProResponse?: { [key: string]: string };
    fraudLabsProRequest?: FraudLabsProRequest;
    nabTransactionRequest?: NabTransactionRequest;
    nabTransactionReponse?: NabTransactionReponse;
}

export interface FraudLabsProRequest {
    IP?: string;
    UserEmail?: null;
    ShipStateCode?: null;
    ShipCountryCode?: null;
    FirstName?: null;
    LastName?: null;
    ShipAddress?: null;
    ShipCity?: null;
    UserEmailDomain?: null;
    UserPhone?: null;
    CardHash?: null;
    BinNumber?: null;
    OrderId?: null;
    Amount?: number;
    Quantity?: number;
    Currency?: null;
    Creditcard?: boolean;
}

export interface NabTransactionReponse {
    summarycode?: number;
    rescode?: null;
    restext?: null;
    refid?: null;
    txnid?: null;
    settdate?: null;
    BankPreauthorisationId?: null;
    pan?: null;
    expirydate?: null;
    merchant?: null;
    timestamp?: null;
    fingerprint?: null;
    token?: null;
    callback_status_code?: null;
    redirect_url?: null;
    response_message?: string;
}

export interface NabTransactionRequest {
    EPS_MERCHANT?: string;
    EPS_TXNTYPE?: number;
    EPS_REFERENCEID?: string;
    EPS_AMOUNT?: number;
    EPS_CURRENCY?: string;
    EPS_TIMESTAMP?: string;
    EPS_FINGERPRINT?: string;
    EPS_RESULTURL?: string;
    EPS_CALLBACKURL?: string;
    EPS_REDIRECT?: boolean;
    '3D_XID'?: string;
    EPS_MERCHANTNUM?: string;
    EPS_CARDNUMBER?: string;
    EPS_EXPIRYMONTH?: string;
    EPS_EXPIRYYEAR?: string;
    EPS_CCV?: string;
    EPS_STORE?: string;
    EPS_STORETYPE?: string;
}

export interface PaymentDeviceModel {
    payload_type?: string;
    account?: string;
}

export interface PayResult {
    payment_gateway?: string;
    reference?: string;
    url_target?: string;
}
export interface PayUnionResult {
    payment_gateway?: string;
    reference?: string;
    url_target?: string;
    pay_result?: any;
}

export interface ICupParams {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: {
        bank_id?: string;
    };
}

export interface IFatParams {
    user?: string;
    trading_account?: string;
    amount?: number;
    currency?: string;
    settlement_currency?: string;
    payment_device_id?: string;
    url_done?: string;
    payload?: {
        user_name?: string;
        user_id?: string;
        user_cardno?: string;
    };
}

export interface IRpnResult {
    reference?: string;
    payment_gateway?: string;
}

export interface IAvodapayVerifying {
    depositReference?: string;
    verifyCode?: string;
}

export interface IAvodapayResult {
    reference?: string;
    payment_gateway?: string;
}

export interface IManualDeposit {
    trading_account?: string;
    amount?: number;
    currency?: string;
}

export enum DepositStatus {
    NEW = 'NEW',
    UPFL = 'UPFL'
}
